import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  Divider,
  Box,
  IconButton,
  Tooltip,
  Grid,
} from "@mui/material";
import { Link, Link as RouterLink } from "react-router-dom";
import { menuItems, menuItemsEmpresa } from "../../utils/sidebar";
import Icon from "../icon";

const Sidebar = ({ onShow, open, drawerWidth, drawerWidthMini, isDesktop }) => {
  const { rol } = useSelector((state) => state.userReducer.user);
  const { isLoading } = useSelector((state) => state.userReducer);
  const [items, setItems] = useState([]);
  setTimeout(() => {
    if (items.length == 0)
      setItems(rol === "empresa" ? menuItemsEmpresa() : menuItems());
  }, 500);

  const defaultBackgroundColor = "#303C54";

  const handleClick = (item) => {
    items.forEach((i) => {
      if (i.key === item.key) {
        i.isSelected = true;
        i.backgroundColor = "black";
      } else {
        i.isSelected = false;
        i.backgroundColor = defaultBackgroundColor;
      }
    });
    setItems([...items]);

    if (isDesktop) {
      onShow();
    }
  };

  if (isLoading) return null;

  return (
    <Box
      sx={{ width: open ? drawerWidth - 1 : drawerWidthMini - 1 }}
      role="presentation"
      onClick={onShow}
    >
      {/* Keeps items below AppBar */}
      <Toolbar />
      <Divider />
      <List>
        {items.map((item) => (
          <ListItemButton
            key={item.key}
            component={RouterLink}
            to={item.path}
            sx={{
              pl: 2.5,
              pr: 2.5,
              backgroundColor: item.backgroundColor,
            }}
            onClick={() => handleClick(item)}
          >
            <ListItemText
              primary={
                <Link to={item.path} className="link">
                  {!open ? (
                    <Tooltip
                      title={
                        <Grid sx={{p:1}}>
                          <Icon name={item.icon} />
                          {item.label}
                        </Grid>
                      }
                      arrow
                      placement="right"
                    >
                      <IconButton
                        sx={{
                          backgroundColor: "#1565C0", // fondo oscuro
                          color: "#fff", // ícono blanco
                          borderRadius: 2,
                          width: 36,
                          height: 36,
                          transition: "0.3s",
                          "&:hover": {
                            backgroundColor: "#3f445c", // contraste al pasar mouse
                          },
                        }}
                      >
                        <Icon name={item.icon} />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <>
                      <Icon name={item.icon} />
                      {item.label}
                    </>
                  )}
                </Link>
              }
              sx={{ color: "white", ml: 0.5 }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

Sidebar.propTypes = {
  onShow: PropTypes.func,
};
Sidebar.defaultProps = {
  onShow: () => {},
};

export default Sidebar;
